<div [id]="chartContainerId"  [style.height.px]="companyId === 4 ? 200 : 400" style="width: 100%;"></div>